import { useEffect, useState } from "react";

const navLinks = [
  { label: "Trang chủ", href: "#home" },
  { label: "Giới thiệu", href: "#about" },
  { label: "Dịch vụ", href: "#services" },
  { label: "Quy trình", href: "#process" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2.5 cursor-pointer">
          <img src="/logo.png" alt="VF Money" className="h-10 w-auto" />
          <div className="flex flex-col leading-tight">
            <span
              className={`text-lg font-bold tracking-tight ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              VF Money
            </span>
            <span
              className={`text-[11px] uppercase tracking-widest ${
                scrolled ? "text-foreground-500" : "text-background-100/80"
              }`}
            >
              Vay nhanh - Tin cậy
            </span>
          </div>
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#download"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Tải ứng dụng
          </a>
        </div>

        <button
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="Mở menu"
        >
          <i className={`text-2xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <ul className="flex flex-col py-2">
            {navLinks.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMobileOpen(false)}
                  className="block px-6 py-3 text-foreground-800 hover:bg-background-100 cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="px-6 py-3">
              <a
                href="#download"
                onClick={() => setMobileOpen(false)}
                className="block w-full text-center bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-semibold px-5 py-3 rounded-full cursor-pointer whitespace-nowrap"
              >
                Tải ứng dụng
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}